import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { OfferCriteriaKind } from "../../../apollo/graphql.generated";
import SegmentedControlMarketplace from "./SegmentedControlMarketplace";
export const offerTypeOptions = [
    {
        value: "",
        label: "All offers",
    },
    {
        value: OfferCriteriaKind.COLLECTION,
        label: "Collection offers",
    },
    {
        value: OfferCriteriaKind.TRAIT,
        label: "Trait offers",
    },
    {
        value: OfferCriteriaKind.TOKEN,
        label: "Item offers",
    },
];
export const nonTokenOfferTypeOptions = offerTypeOptions.slice(0, 3);
function OfferTypeFilter({ offerType, setOfferType, options = offerTypeOptions, }) {
    return (_jsx(SegmentedControlMarketplace, { value: offerType, onChange: (e) => setOfferType(e), data: options, invertedColorActive: true }));
}
export default OfferTypeFilter;
